<template>
    <div class="logo" :class="classes">
        <a
            target="_blank"
            href="https://www.nespresso.com?utm_source=nespresso-edition&utm_medium=Referral&utm_campaign=nespresso-edition"
        >
            <visual :svg="logo" />
        </a>
    </div>
</template>

<script>
import Visual from 'gvue/src/core/Visual'

import getImage from '@/helpers/image'

export default {
    name: 'LogoNespresso',
    components: { Visual },
    props: {
        size: {
            type: String,
            default: 'M'
        }
    },
    computed: {
        logo() {
            return getImage({
                type: 'icon',
                name: 'logo_nespresso',
                landing: this.$landing
            })
        },
        classes() {
            return {
                S: 'small',
                M: 'medium'
            }[this.size]
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
::v-deep .g_visual
    display: block
    height: pxToRem(30)
    width: auto
    fill: $color_black

.small
    ::v-deep .g_visual
        height: pxToRem(16)

+mobile
    ::v-deep .g_visual
        height: pxToRem(16)
</style>
